/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Ignore_Timecodes_HelpInputs */



/**
* | output |
* | --- |
* | "Strip timecodes (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) from the transcript" |
*
* @param {Plain_Text_Import_Ignore_Timecodes_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_ignore_timecodes_help = /** @type {((inputs?: Plain_Text_Import_Ignore_Timecodes_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Ignore_Timecodes_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer les timecodes (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) de la transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entfernen Sie die Zeitstempel (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) aus dem Transkript.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovere i codici temporali (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) dalla trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалите из транскрипта временные коды (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm).")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar códigos de tiempo (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) de la transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从转录稿中去除时间码（hh:mm:ss:ff、hh:mm:ss、hh:mm:ss:mmm）。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプトからタイムコード（hh:mm:ss:ff、hh:mm:ss、hh:mm:ss:mmm）を削除します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रांसक्रिप्ट से टाइमकोड (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) हटा दें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Extrair os códigos de tempo (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) da transcrição.")
	return /** @type {LocalizedString} */ ("Strip timecodes (hh:mm:ss:ff, hh:mm:ss, hh:mm:ss:mmm) from the transcript")
});